import { SyslogAttackStatus } from './syslog-attack-status'

export { SyslogSettingsForm } from './syslog-settings-form'

export { syslogIsDifferent } from './syslog-is-different'

export interface SyslogSettingsFormState {
  readonly port?: number
  readonly host?: string
  readonly protocol: SyslogProtocol
  readonly facilityCode: number
  readonly severityByAttackStatus: SyslogSeverityByAttackStatus
}

export type SyslogSeverityByAttackStatus = Record<
  SyslogAttackStatus,
  SyslogSeverity
>

export const defaultSeverityByAttackStatus: SyslogSeverityByAttackStatus = {
  [SyslogAttackStatus.EXPLOITED]: 'ALERT',
  [SyslogAttackStatus.SUSPICIOUS]: 'CRITICAL',
  [SyslogAttackStatus.BLOCKED]: 'ERROR',
  [SyslogAttackStatus.BLOCKED_PERIMETER]: 'WARNING',
  [SyslogAttackStatus.PROBED]: 'INFO'
}

export const defaultSyslogSettingsFormState: SyslogSettingsFormState = {
  port: undefined,
  host: undefined,
  protocol: 'UDP' as SyslogProtocol,
  facilityCode: 19,
  severityByAttackStatus: defaultSeverityByAttackStatus
}

export type SyslogSeverity =
  | 'DEBUG'
  | 'NOTICE'
  | 'ALERT'
  | 'INFO'
  | 'CRITICAL'
  | 'ERROR'
  | 'WARNING'

export type SyslogProtocol = 'UDP' | 'TCP' | 'TCP_AND_TLS'
